import { useQuery } from '@apollo/client/react';

import { SalesTaxDocument } from '@graphql/platform';
import { AvalaraTaxItemCode } from '@graphql/platform';

import { useSharedCheckoutContext } from '@root/components/checkout/context';

import { TaxRateQueryState } from './use_storage_tax_rate';

export const useProtectionTaxRate = (): TaxRateQueryState => {
  const {
    flowState: { values },
  } = useSharedCheckoutContext();
  const zip = values.address?.zip?.trim() || values.zip?.trim();

  const { data, loading, error } = useQuery(SalesTaxDocument, {
    variables: {
      zipCode: zip!,
      avalaraItemCode: AvalaraTaxItemCode.Default,
    },
    skip: !zip,
  });

  return {
    percent: data?.salesTax != null ? data.salesTax.percent : undefined,
    loading: Boolean(zip) && loading,
    error: error ?? undefined,
  };
};
